module.exports = __webpack_public_path__ + "static/media/kirby-group.c717fecb.png";